export default {
    other: '其他',
    home: '首页',
    product: '产品',
    server: '服务',
    case: '成功案例',
    jobs: '就业机会',
    about: '关于我们',
    productTitle: '新品推荐',
    more: '更多',
    newsTitle: '企业新闻',
    caseTitle: '让客户满意交钥匙的服务',
    introduction: '公司简介',
    concat: '联系我们',
    intDes: ' 来自加拿大的TORVANDOM, 长期专著于为工业,电力及基础建设市场的广大用户提供其关键设备设施的密封和电气保护解决方案. 在长期不断的实践当中研发出了一系列可靠而高效的产品',
    company: '拓万牧（苏州）工业有限公司',
    address: '苏州市吴中区郭巷街道通达路1301号独墅湖大厦4C-2室',
    phone: '电话：0512-66872807'

}



// WEBPACK FOOTER //
// ./src/locales/zh-CN.js